














































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { Base, SurveyModel, Question, QuestionRowModel } from "survey-core";
import { getComponentName } from "./question";
import { BaseVue } from "./base";

@Component
export class SurveyElementVue extends BaseVue {
  @Prop() css: any;
  @Prop() survey: SurveyModel;
  @Prop() element: any;
  @Prop() row: QuestionRowModel;
  protected getModel(): Base {
    return this.element;
  }
  getComponentName(element: Question) {
    return getComponentName(element);
  }
  getContentClass(element: Question) {
    return element.cssContent;
  }
  get hasErrorsOnTop() {
    return !this.element.isPanel && (<Question>this.element).showErrorOnTop;
  }
  get hasErrorsOnBottom() {
    return !this.element.isPanel && (<Question>this.element).showErrorOnBottom;
  }
  previousElement: HTMLElement;
  afterRender(el: HTMLElement) {
    if (!this.element.isPanel && this.previousElement !== el && el && el instanceof HTMLElement) {
      (<Question>this.element).afterRender(el);
    }
    this.previousElement = el;
  }
  onUpdated() {
    this.afterRender(this.$refs.root as HTMLElement);
  }
  mounted(): void {
    this.afterRender(this.$refs.root as HTMLElement);
  }
  destroyed(): void {
    this.previousElement = undefined as any;
  }
}
Vue.component("survey-element", SurveyElementVue);
export default SurveyElementVue;
